import React from 'react';
import { Stat } from '../types';

interface StatsGridProps {
    stats: Stat[];
    isLoaded: boolean;
}

const StatsGrid: React.FC<StatsGridProps> = ({
    stats,
    isLoaded,
}) => (
    <div className="w-full max-w-full mx-auto grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mt-8 sm:mt-20 px-0 sm:px-2">
        {stats.map((stat, idx) => {
            const Icon = stat.icon;
            return (
                <div
                    key={idx}
                    className={`group relative bg-white/5 backdrop-blur-xl rounded-2xl sm:rounded-3xl p-4 sm:p-8 border border-white/10 hover:border-yellow-400/50 transition-all duration-700 hover:scale-105 hover:-translate-y-2 w-full max-w-full ${isLoaded
                        ? 'opacity-100 translate-y-0'
                        : 'opacity-0 translate-y-10'
                        }`}
                    style={{ transitionDelay: `${idx * 150}ms` }}
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/10 to-transparent rounded-2xl sm:rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <div className="relative z-10 text-center">
                        <div
                            className={`w-10 h-10 sm:w-16 sm:h-16 bg-gradient-to-r ${stat.color} rounded-xl sm:rounded-2xl flex items-center justify-center mx-auto mb-2 sm:mb-4 group-hover:scale-110 transition-transform duration-300`}
                        >
                            <Icon className="w-5 h-5 sm:w-8 sm:h-8 text-white" />
                        </div>
                        <div className="text-2xl sm:text-4xl font-bold text-white mb-1 sm:mb-2 group-hover:text-yellow-400 transition-colors duration-300">
                            {stat.number}
                        </div>
                        <div className="text-xs sm:text-sm text-slate-400 group-hover:text-slate-300 transition-colors duration-300">
                            {stat.label}
                        </div>
                    </div>
                </div>
            );
        })}
    </div>
);

export default StatsGrid;
